"use client";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "./auth";

export default function Home() {
  const router = useRouter();
  const authContext = useAuth();
  const loading = authContext?.loading ?? true;
  const user = authContext?.user ?? null;

  useEffect(() => {
    if (loading) return;
    router.replace(user ? "/dashboard" : "/login");
  }, [loading, user, router]);

  if (loading) {
    return <p>Carregando...</p>;
  }

  return null;
}
